function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_attention",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u9577\\u65B9\\u5F62_2167",
  "data-name": "\\u9577\\u65B9\\u5F62 2167",
  width: 100,
  height: 100,
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u30B0\\u30EB\\u30FC\\u30D7_2321",
  "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2321",
  transform: "translate(0 5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_926_1_",
  d: "M83.063,90H16.168C9.5,90,4.157,87.333,1.655,83.333c-2.669-4.667-2-10.333,1.5-16l33.2-58C40.023,3.167,44.694,0,49.866,0s9.842,3.167,13.512,9.333l33.7,58a16.187,16.187,0,0,1,1.5,16C95.574,87.333,90.4,90,83.063,90ZM49.866,5.167c-3.17,0-6.172,2.667-8.841,6.667l-33.7,57.5c-2,4.667-2.669,8.333-1,11.333,1.5,2.667,5.171,4.167,9.842,4.167H83.063c4.671,0,8.341-1.5,9.842-4.167s1-6.667-1.5-10.833l-32.7-58C56.038,7.833,53.035,5.167,49.866,5.167Z",
  transform: "translate(-0.02)",
  fill: "#68b7e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_1614",
  "data-name": "\\u30D1\\u30B9 1614",
  d: "M27,43.233a4.654,4.654,0,0,0,1.333,3.333A4.955,4.955,0,0,0,31.667,47.9h0A4.654,4.654,0,0,0,35,46.567,4.833,4.833,0,0,0,31.5,38.4,4.78,4.78,0,0,0,27,43.233Z",
  transform: "translate(18.012 25.6)",
  fill: "#68b7e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_1615",
  "data-name": "\\u30D1\\u30B9 1615",
  d: "M31.9,48.5c2.833,0,4.833-18.167,4.833-27.667A4.947,4.947,0,0,0,31.9,16h-.167A4.837,4.837,0,0,0,26.9,20.833C27.067,29,28.9,48.5,31.9,48.5Z",
  transform: "translate(17.946 10.667)",
  fill: "#68b7e6"
})));

var SvgIconAttention = function SvgIconAttention(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAttention, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_attention.b10d95d4.svg";
export { ForwardRef as ReactComponent };